// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/DMSans-VariableFont_opsz,wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/DMSans-Italic-VariableFont_opsz,wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/REM-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/REM-Italic-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'DMSans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-weight: 100 900;
  font-style: normal;
}
@font-face {
  font-family: 'DMSans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
  font-weight: normal;
  font-style: italic;
}
@font-face {
  font-family: 'REM';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
  font-weight: 100 900;
  font-style: normal;
}
@font-face {
  font-family: 'REM';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
  font-weight: normal;
  font-style: italic;
}

html {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: 'DMSans', sans-serif;
  font-size: 16px;
}

*,
*:before,
*:after {
  box-sizing: inherit;
}

body {
  margin: 0;
  padding: 0;
  min-width: 100%;
  min-height: 100vh;
}

h1, 
h2, 
h3, 
h4, 
h5, 
h6 {
  font-family: 'REM', sans-serif;
}

h1 {
  font-size: 48px;
}

h2 {
  font-size: 24px;
}

p {
  margin: 0;
}

button {
  font-family: 'REM', sans-serif;
}

#rem {
  font-family: 'REM', sans-serif;
}
#dm-sans {
  font-family: 'DMSans', sans-serif;
}

@media (min-width: 1800px) {
  html {
    font-size: 18px;
  }
}

@media (max-width: 1365px) {
  html {
    font-size: 14px;
  }
}

@media (max-width: 1280px) {
  html {
    font-size: 12px;
  }
}

a:hover, 
u:hover, 
button:hover {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,+DAA+E;EAC/E,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,+DAAsF;EACtF,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,+DAAuE;EACvE,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,+DAA8E;EAC9E,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,iCAAiC;EACjC,eAAe;AACjB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;;;;EAME,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;;;EAGE,eAAe;AACjB","sourcesContent":["@font-face {\n  font-family: 'DMSans';\n  src: url('./assets/fonts/DMSans-VariableFont_opsz,wght.ttf') format('truetype');\n  font-weight: 100 900;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'DMSans';\n  src: url('./assets/fonts/DMSans-Italic-VariableFont_opsz,wght.ttf') format('truetype');\n  font-weight: normal;\n  font-style: italic;\n}\n@font-face {\n  font-family: 'REM';\n  src: url('./assets/fonts/REM-VariableFont_wght.ttf') format('truetype');\n  font-weight: 100 900;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'REM';\n  src: url('./assets/fonts/REM-Italic-VariableFont_wght.ttf') format('truetype');\n  font-weight: normal;\n  font-style: italic;\n}\n\nhtml {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  font-family: 'DMSans', sans-serif;\n  font-size: 16px;\n}\n\n*,\n*:before,\n*:after {\n  box-sizing: inherit;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  min-width: 100%;\n  min-height: 100vh;\n}\n\nh1, \nh2, \nh3, \nh4, \nh5, \nh6 {\n  font-family: 'REM', sans-serif;\n}\n\nh1 {\n  font-size: 48px;\n}\n\nh2 {\n  font-size: 24px;\n}\n\np {\n  margin: 0;\n}\n\nbutton {\n  font-family: 'REM', sans-serif;\n}\n\n#rem {\n  font-family: 'REM', sans-serif;\n}\n#dm-sans {\n  font-family: 'DMSans', sans-serif;\n}\n\n@media (min-width: 1800px) {\n  html {\n    font-size: 18px;\n  }\n}\n\n@media (max-width: 1365px) {\n  html {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 1280px) {\n  html {\n    font-size: 12px;\n  }\n}\n\na:hover, \nu:hover, \nbutton:hover {\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
